import {BaseFormModel} from './base-form-model';
import {DonationProgram} from './donation-program';
import {Person} from './person';

export class DonationProgramPayout extends BaseFormModel<DonationProgramPayout> {
    id: number;
    amount: number;
    method: string;
    donationProgram: DonationProgram;
    createDate: Date;
    createdBy: Person;
}
